import React from 'react';
import BaseDialog from '../../components/dialog/BaseDialog';
import {
	useTranslate,
	useNotify,
	required,
	TextInput,
	useCreate,
	refreshView,
} from 'react-admin';
import { useDispatch } from 'react-redux';
import IconVisibility from '@material-ui/icons/Visibility';
import IconVisibilityOff from '@material-ui/icons/VisibilityOff';
import { Form } from 'react-final-form';

const AddToWatchList = ({ record, version, isSubmitting }) => {
	const translate = useTranslate();
	const notify = useNotify();
	const dispatch = useDispatch();
	const isOnWatchList = record.onWatchList;
	const [addOrRemoveFromWatchList] = useCreate('users');

	const handleSubmit = (values, hideDialog) => {
		addOrRemoveFromWatchList(
			{
				payload: {
					id: record.id,
					data: values,
					method: isOnWatchList ? 'removeFromWatchList' : 'addToWatchList',
				},
			},
			{
				onSuccess: () => {
					notify(isOnWatchList ? 'resources.users.notifications.removedFromWatchList' : 'resources.users.notifications.addedToWatchList');
					hideDialog();
					dispatch(refreshView());
				},
				onFailure: (error) => {
					notify(error.message, 'error');
				},
			},
		);
	};
	return (
		<BaseDialog
			icon={isOnWatchList ? <IconVisibilityOff /> : <IconVisibility />}
			isSubmitting={isSubmitting}
			buttonDisabled={false}
			buttonLabel={translate(isOnWatchList ? 'resources.users.labels.removeFromWatchList' : 'resources.users.labels.addToWatchList')}
			dialogTitle={translate(isOnWatchList ? 'resources.users.labels.removeFromWatchList' : 'resources.users.labels.addToWatchList')}
			handleSubmit={handleSubmit}
		>
			{({ handleSubmit, hideDialog }) => (
				<Form
					initialValues={record}
					onSubmit={values => handleSubmit(values, hideDialog)}
					key={version}
					keepDirtyOnReinitialize
					render={({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<TextInput variant="standard" source={"description"} validate={required()} resettable multiline fullWidth/>
						</form>
					)}
				/>
			)}
		</BaseDialog>
	);
};

export default AddToWatchList;
